import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import BroadcastsAPI from '../../api/broadcasts';

export const state = {
  records: [],
  previews: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isPreviewing: false,
    isTriggering: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getBroadcasts(_state) {
    return _state.records;
  },
  getBroadcast: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
  getPreview: _state => id => {
    return _state.previews[id];
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isFetching: true });
    try {
      const response = await BroadcastsAPI.get();
      commit(types.SET_BROADCASTS, response.data);
    } finally {
      commit(types.SET_BROADCAST_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, broadcastObj) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isCreating: true });
    try {
      const response = await BroadcastsAPI.create(broadcastObj);
      commit(types.ADD_BROADCAST, response.data);
      return response.data;
    } finally {
      commit(types.SET_BROADCAST_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isUpdating: true });
    try {
      const response = await BroadcastsAPI.update(id, updateObj);
      commit(types.EDIT_BROADCAST, response.data);
      return response.data;
    } finally {
      commit(types.SET_BROADCAST_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isDeleting: true });
    try {
      await BroadcastsAPI.delete(id);
      commit(types.DELETE_BROADCAST, id);
    } finally {
      commit(types.SET_BROADCAST_UI_FLAG, { isDeleting: false });
    }
  },
  preview: async ({ commit }, id) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isPreviewing: true });
    try {
      const response = await BroadcastsAPI.preview(id);
      commit('SET_BROADCAST_PREVIEW', { id, preview: response.data });
      return response.data;
    } finally {
      commit(types.SET_BROADCAST_UI_FLAG, { isPreviewing: false });
    }
  },
  trigger: async ({ commit, dispatch }, id) => {
    commit(types.SET_BROADCAST_UI_FLAG, { isTriggering: true });
    try {
      await BroadcastsAPI.trigger(id);
      // The trigger is asynchronous; re-fetching picks up the new status and counters.
      await dispatch('get');
    } finally {
      commit(types.SET_BROADCAST_UI_FLAG, { isTriggering: false });
    }
  },
};

export const mutations = {
  [types.SET_BROADCAST_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_BROADCAST_PREVIEW(_state, { id, preview }) {
    _state.previews = { ..._state.previews, [id]: preview };
  },

  [types.ADD_BROADCAST]: MutationHelpers.create,
  [types.SET_BROADCASTS]: MutationHelpers.set,
  [types.EDIT_BROADCAST]: MutationHelpers.update,
  [types.DELETE_BROADCAST]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
